// FormKitSchema renders sibling schema nodes WITHOUT Vue keys, so when a
// conditional field (`if`) toggles, Vue reuses the component instance already
// sitting in that slot. A FormKit input builds its section schema once in
// setup(), so a reused instance keeps the OLD input's markup while its node type
// and classes update to the new one. On employee_records that meant picking
// "Doctor Note" produced a field labelled "Doctor Note Date" rendering the file
// picker left behind by "Apparel - Front Photo" (which is on screen at first
// paint, because record_type defaults to "Apparel Approval") instead of a date
// picker. A stable key per node forces a fresh instance instead of a patch.
//
// Top-level nodes only: the failure needs conditional siblings, and the one
// nested schema we build (upload_repeater) has a single unconditional child.
// `key` is consumed by Vue as the vnode key and never reaches FormKit's props,
// so it does not collide with the internal key FormKit puts on node attrs.
export const with_stable_keys = (nodes) => {
  if (!Array.isArray(nodes)) {
    return nodes;
  }
  return nodes.map((node, index) => {
    if (!node || typeof node !== 'object' || 'key' in node) {
      return node;
    }
    return { ...node, key: `${node.name ?? node.id ?? node.$el ?? 'node'}_${index}` };
  });
};
